import { Component, OnInit } from '@angular/core';
import { InvoicePriceService } from '@app/Modules/in-voice/Services/invoice-price.service';
import { AppService } from '@app/Modules/Shared/Services/app.service';
import { HttpInvoicePriceService } from '@app/Modules/Shared/Services/http-invoice-price.service';

@Component({
  selector: 'app-advanced-invoice-favourite',
  templateUrl: './advanced-invoice-favourite.component.html',
  styleUrls: ['./advanced-invoice-favourite.component.scss']
})
export class AdvancedInvoiceFavouriteComponent implements OnInit {

  params: any;
  isFavorite: boolean = false;
  isGlobalUser: boolean = false;

  constructor(private httpInvoiceService: HttpInvoicePriceService,
              private appService: AppService,
              private invoicePriceService: InvoicePriceService) { }

  agInit(params: any) {
    this.params = params;
    if(params.data && params.data.isFavorite){
      this.isFavorite = true;
    } else {
      this.isFavorite = false;
    }
    this.isGlobalUser = this.appService.isGlobalUser;
  }

  ngOnInit() {
  }

  setUnsetFavourite(isSetToFav){
    this.appService.setLoadingStatus(true);
    let request = {
      userId: this.appService.getuserId(false),
      favoriteCategoryList: [
        {
          categoryCode: this.params.data.categoryCode,
          isFavorite: isSetToFav
        }
      ]
    };
    this.httpInvoiceService.saveFavoriteInvoiceCategory(request).subscribe( res => {
      if(res.statusMessage == "Success"){
        this.invoicePriceService.setRedrawAdvancedGridRow([{isFavorite: isSetToFav, categoryCode: this.params.data.categoryCode}]);
      }      
    }, (e) => {

    }, () => {
      this.appService.setLoadingStatus(false);
    });
  }

}
